import { ENV } from 'evcharging/app';

export const createCmsApiBaseUrl = (): string => ENV.CMS_API_BASE_URL;
export const createCmsAssetUrl = (assetId: string): string =>
  `${createCmsApiBaseUrl()}/assets/${assetId}}`;
